module.exports = __webpack_public_path__ + "img/67.f67d9625.png";